<template>
  <footer class="mobilefooter">
    <el-collapse accordion style="padding-left: 5%">
      <el-collapse-item title="JoyOders" name="1" class="collbox">
        <div class="details"><a href="/MerchantList " style="color: black">商家</a></div>
        <div class="details"><a href="/TaskMarket " style="color: black">任务市场</a></div>
        <!-- <div class="details"><a href="https://bbs.joyorders.com" style="color: black">论坛</a></div> -->
      </el-collapse-item>
      <el-collapse-item title="帮助" name="2" class="collbox">
        <div class="details" @click="contact()">常见问题</div>
        <div class="details"><a href="/tracktask">跟踪任务</a></div>
        <div class="details" @click="contact()" href="javascript:void(0)">联系我们</div>
      </el-collapse-item>
      <el-collapse-item title="公司" name="3" class="collbox">
        <div class="details"><a href="/Company">关于我们</a></div>
        <div class="details"><a href="/Company">人才招聘</a></div>
        <div class="details"><a href="/Company">合作洽谈</a></div>
      </el-collapse-item>
      <el-collapse-item title="关注我" name="4" class="collbox">
        <div class="picdetails">
          <img src="../assets/images/homepage/addWx.jpg" height="128" width="128"/>
        </div>
      </el-collapse-item>
      <el-collapse-item title="支付方式" name="4" class="collbox">
        <div class="details">
          <i class="ico ico-wechat"></i>
          <i class="ico ico-ali"></i>
          <!--<i class="ico ico-social-paypal"></i>-->
        </div>
      </el-collapse-item>
    </el-collapse>
  </footer>
</template>

<script>
  let $ = require('jQuery')
  export default {
    name: 'mobilefooter',
    methods: {
      scrolltobueyer() {
        if (this.pathname != 'home') {
          this.$router.push('/')
        }
        document.querySelector('.buyer').scrollIntoView(false)
      },
      contact () {
          this.$router.push({path:'/HelpCenter', query:{category:'contact'}})
      }
    }
  }

</script>

<style  lang="scss">
  .mobilefooter {
    .is-active{
      -webkit-transform: rotate(0deg) !important;
       transform: rotate(0deg)!important;
      .el-icon-arrow-right:before {
        content: "\e6d8";
      }
    }
      .el-icon-arrow-right:before {
        content: "\e6d9";
      }
    .collbox {
      color: #343434 !important;
    }

    .details {
      color: black !important;
      margin: 20px 0 20px 5% !important;
      a {
        color: black !important;
      }
    }
    .picdetails{
      margin: 20px 30% 20px 30% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mobilefooter.vue